import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const EquipmentReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                equipment:[]
            }, action) => {
                
    switch (action.type) {
        // case ActionTypes.ADD_EMPLOYEES:
        //     return {...state, isLoading: false, errMess: null, employees: action.payload};

        // case ActionTypes.EMPLOYEES_LOADING:
        //     return {...state, isLoading: true, errMess: null, employees: []}

        // case ActionTypes.EMPLOYEES_FAILED:
        //     return {...state, isLoading: false, errMess: action.payload};

        // case ActionTypes.ADD_EMPLOYEE:
        //     const nEmployee = action.payload;
        //     return {...state, isLoading: false, errMess: null, employees: state.employees.concat(nEmployee)};
    
        // case ActionTypes.UPDATE_EMPLOYEE:
        //     const uEmployee = action.payload;
        //     const updatedEmployees = state.employees.map(e => e.id === uEmployee.id ? uEmployee : e );
        //     return {...state, isLoading: false, errMess: null, employees: updatedEmployees};

        // case ActionTypes.DELETE_EMPLOYEE:
        //     const deId = action.payload;
        //     console.log('delete: ' + deId);
        //     const filteredEmployees = state.employees.filter(e => e.id !== deId);
        //     return {...state, isLoading: false, errMess: null, employees: filteredEmployees};

        default:
            return state;
    }
};